import React, { createContext, useContext } from 'react'
import { LegalDepositType } from '../types'
import { CurrentLegalFormalityContext } from './LegalFormalityContext'

export interface ILegalDepositsContextValue {
  deposits: LegalDepositType[]
}

export const LegalDepositsContext = createContext(
  {} as ILegalDepositsContextValue
)

const LegalDepositsContextProvider = ({
  children,
}: {
  children: React.ReactNode
}) => {
  const { legalFormality } = useContext(CurrentLegalFormalityContext)
  const deposits = legalFormality.legalDeposits ?? []

  return (
    <LegalDepositsContext.Provider value={{ deposits }}>
      {children}
    </LegalDepositsContext.Provider>
  )
}

export default LegalDepositsContextProvider
